// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg-11.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Logirent-Regular-Demo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.module.css */

.gapsy-dashboard_pageFullBackground__gyEDE {
  /* margin: 0; */
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  font-size: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}

.gapsy-dashboard_mainHeader__VunT4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  position: sticky;
  top: 0;
  z-index: 1030;
  height: 56px;
  color: white;
  display: flex;
  align-items: center;
  padding: 0 1rem;
}

.gapsy-dashboard_stickyNav__kQu\\+i {
  position: sticky;
  top: 56px;
  z-index: 1020;
  background-color: #366872;
  color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.gapsy-dashboard_navLink__\\+s\\+wp {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: white;
}

.gapsy-dashboard_active__NeJ7k.gapsy-dashboard_navLink__\\+s\\+wp {
  color: #ffd166;
  padding: 6px 10px;
  text-decoration: none;
}

.gapsy-dashboard_navLinkDefault__reYk5 {
  padding: 6px 10px;
  text-decoration: none;
}

.gapsy-dashboard_badgeSmall__hfer8 {
  font-size: 0.7rem;
}

.gapsy-dashboard_hoverText__vvDCM:hover {
  color: #03045e !important;
}

.gapsy-dashboard_textInfo__lMhLf {
  color: #000 !important;
}

.gapsy-dashboard_dropdownSubmenuList__euzgm {
  top: 0;
  left: 100%;
  margin-top: -1px;
}

.gapsy-dashboard_dropdownToggleArrow__\\+sgBb::after {
  border-left: 0.3em solid transparent;
  border-right: 0.3em solid transparent;
  border-top: 0.3em solid;
  content: "";
  float: right;
  margin-top: 0.5em;
  margin-left: 0.5em;
}

.gapsy-dashboard_dropdownItem__80cqI {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.gapsy-dashboard_dropdownMenu__ccoAg {
  min-width: 200px;
}

.gapsy-dashboard_dropdownMenuStyled__U1G4P {
  background-color: #366872;
  color: #fff;
  border: none;
}

/* Add scroll to dropdown */
.gapsy-dashboard_dropdownMenu__ccoAg {
  max-height: 200px;
  /* Adjust as needed for ~5 items */
  overflow-y: auto;
}

/* Optional: scrollbar styling for the dropdown */
.gapsy-dashboard_dropdownMenu__ccoAg::-webkit-scrollbar {
  width: 6px;
}

.gapsy-dashboard_dropdownMenu__ccoAg::-webkit-scrollbar-thumb {
  background-color: #7cbbc8;
  border-radius: 3px;
}

.gapsy-dashboard_dropdownMenu__ccoAg {
  max-height: 160px;
  overflow-y: auto;
  max-width: 240px;
  /* or set a fixed width if needed */
  white-space: normal;
  /* allow wrapping */
  word-break: break-word;
  /* break long words if needed */
  padding-right: 4px;
}

.gapsy-dashboard_dropdownMenu__ccoAg::-webkit-scrollbar {
  width: 6px;
}

.gapsy-dashboard_dropdownMenu__ccoAg::-webkit-scrollbar-thumb {
  background-color: #7cbbc8;
  border-radius: 3px;
}

/* Submenu Dropdown */
.gapsy-dashboard_dropdownSubmenu__kuUjC {
  position: relative;
}

.gapsy-dashboard_submenu__x3iHJ {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  margin-top: -0.125rem;
  min-width: 200px;
  z-index: 1050;
}

.gapsy-dashboard_dropdownSubmenu__kuUjC:hover .gapsy-dashboard_submenu__x3iHJ {
  display: block;
}


.gapsy-dashboard_dropdownMenuStyled__U1G4P a,
.gapsy-dashboard_dropdownMenuStyled__U1G4P i {
  color: #fff !important;
}

.gapsy-dashboard_mainContainer__dawLX {
  display: flex;
  flex-direction: row;
}

.gapsy-dashboard_formLabel__2xN41 {
  margin-top: 0.5rem;
}

.gapsy-dashboard_chartContainer__j90OE {
  display: flex;
  align-items: center;
}

.gapsy-dashboard_legend__JE6xZ {
  font-size: 12px;
}

.gapsy-dashboard_legendItem__SCZQS {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  color: #fff;
}

.gapsy-dashboard_legendColor__XPc9M {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

@media (max-width: 768px) {
  .gapsy-dashboard_main-container__iwI9v {
    flex-direction: column;
  }
}

/* Position the submenu to the right */
.gapsy-dashboard_dropdownSubmenu__kuUjC .gapsy-dashboard_dropdownMenu__ccoAg {
  top: 0;
  left: 100%;
  margin-top: -0.125rem;
  display: none;
  opacity: 0;
  transform: translateX(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Show submenu on hover */
.gapsy-dashboard_dropdownSubmenu__kuUjC:hover>.gapsy-dashboard_dropdownMenu__ccoAg {
  display: block;
  opacity: 1;
  transform: translateX(0);
}

/* Prevent submenu from closing parent */
.gapsy-dashboard_dropdownSubmenu__kuUjC>.gapsy-dashboard_dropdownToggle__va2pM::after {
  content: " \\25B6";
  /* Right arrow */
  float: right;
}

.gapsy-dashboard_dropdownMenu__ccoAg .gapsy-dashboard_dropdownItem__80cqI i {
  color: #6c757d;
}

.gapsy-dashboard_dropdownMenu__ccoAg a.gapsy-dashboard_dropdownItem__80cqI:hover {
  background-color: #ccc;
}

a.gapsy-dashboard_dropdownItem__80cqI,
.gapsy-dashboard_dropdown-adjustables__AELam {
  font-size: 12px;
}

.gapsy-dashboard_card__cHaOX {
  background: none;
  border: 1px solid #3d405b !important;
}

.gapsy-dashboard_borderBottom__RiHZX {
  border-bottom: 1px solid #3d405b !important;
}

.gapsy-dashboard_borderTop__\\+Fvr0 {
  border-top: 1px solid #3d405b !important;
}

.gapsy-dashboard_cardBorder__vjAx0 {
  border: 1px solid #3d405b !important;
}

.gapsy-dashboard_card__cHaOX h6 {
  color: #000;
}

.gapsy-dashboard_card__cHaOX a {
  color: #000;
}

.gapsy-dashboard_customCardChart__bvPcO {
  background: #fff;
  border-radius: 0px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: 0.3s ease;
}

.gapsy-dashboard_customCardChart__bvPcO h6 {
  font-size: 12px;
}

.gapsy-dashboard_customCardChart__bvPcO:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.gapsy-dashboard_circleValue__B2Xk6 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(45deg, #667eea, #764ba2);
  /* Indigo to Purple */
  font-size: 16px;
}

@font-face {
  font-family: "Logirent Demo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  /* format should be 'truetype' for .ttf files */
}

.gapsy-dashboard_h5LogoFont__cTQaN {
  font-family: "Logirent Demo", sans-serif !important;
}

li.gapsy-dashboard_navItem__GxHA1 a {
  font-size: 12px !important;
}

footer a {
  font-size: 12px;
}

.gapsy-dashboard_legendItem__SCZQS {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.gapsy-dashboard_legendColor__XPc9M {
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 5px;
  border-radius: 3px;
}

.gapsy-dashboard_legendLabel__R8Q-I {
  white-space: nowrap;
}

.gapsy-dashboard_legendItem__SCZQS {
  font-size: 0.25rem;
  gap: 5px;
  white-space: nowrap;
}

.gapsy-dashboard_legendItem__SCZQS {
  display: flex;
  align-items: center;
  gap: 5px;
  /* spacing between color dot and label */
  font-size: 13px;
  white-space: nowrap;
}

#gapsy-dashboard_chartLegend__H4rx1 {
  display: flex;
  justify-content: center;
  gap: 10px;
  /* space between legend items */
  flex-wrap: nowrap;
  /* <== prevents wrapping to next row */
  font-size: 13px;
  margin-top: 10px;
}

.gapsy-dashboard_legendItem__SCZQS {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.gapsy-dashboard_legendColor__XPc9M {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
}

.gapsy-dashboard_legendLabel__R8Q-I {
  display: inline;
  line-height: 1;
}

.gapsy-dashboard_chartLegend__H4rx1 .gapsy-dashboard_legendLabel__R8Q-I {
  font-size: 12px !important;
  margin-left: 4px;
}

.gapsy-dashboard_customBox__Q142H {
  color: #fff;
  border-radius: 12px;
  padding: 3px;
  text-align: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.gapsy-dashboard_customBox__Q142H:hover {
  transform: translateY(-5px);
  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); */
}

.gapsy-dashboard_customBox__Q142H i {
  font-size: 28px;
  display: block;
  transition: transform 0.3s ease;
}

.gapsy-dashboard_customBox__Q142H:hover i {
  transform: rotate(10deg) scale(1.1);
}


.gapsy-dashboard_box__wQhcQ {
  cursor: pointer;
  transition: all 0.3s ease;
}

.gapsy-dashboard_box__wQhcQ:hover {
  transform: translateY(-5px);
  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); */
}

.gapsy-dashboard_box__wQhcQ i {
  /* font-size: 28px;
  display: block; */
  transition: transform 0.3s ease;
}

.gapsy-dashboard_box__wQhcQ:hover i {
  transform: rotate(10deg) scale(1.1);
}

/* Box-specific gradient classes */
.gapsy-dashboard_csBoxMain__QZIFU {
  /* background: linear-gradient(45deg, #3949AB, #2962FF); */
  /* background: linear-gradient(45deg, #7f5539, #b08968); */
  /* background: linear-gradient(45deg, #450920, #da627d); */
  background: linear-gradient(45deg, #07beb8, #967aa1);
}

.gapsy-dashboard_csBoxBlue__MhNKh {
  /* background: linear-gradient(45deg, #1E88E5, #42A5F5); */
  /* background: linear-gradient(45deg, #f25c54, #f4845f); */
  background: linear-gradient(45deg, #f25c54, #967aa1);
}

.gapsy-dashboard_csBoxPurple__lvYz- {
  /* background: linear-gradient(45deg, #5E35B1, #7E57C2); */
  /* background: linear-gradient(45deg, #6a11cb, #03f95d); */
  /* background: linear-gradient(45deg, #133c55, #386fa4); */
  background: linear-gradient(45deg, #ffc43d, #967aa1);
}

.gapsy-dashboard_csBoxDarkGreen__59AgF {
  /* background: linear-gradient(45deg, #1b9c85, #43aa8b); */
  background: linear-gradient(45deg, #133c55, #967aa1);
}

/* Override for Overall Workflow (group3) boxes */
.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_csBoxTeal__74uY9 {
  background-color: #f8f9fa;
  /* light neutral bg */
  border: 2px solid #133c55;
  color: #133c55;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_csBoxYellow__HXgKi {
  background-color: #f8f9fa;
  border: 2px solid #f8f9fa;
  color: #000;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_csBoxGreen__neHD8 {
  background-color: #f8f9fa;
  /* border: 2px solid #770058;
                        color: #600047; */
  border: 2px solid #07beb8;
  color: #07beb8;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_customBox__Q142H i {
  color: inherit;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_customBox__Q142H {
  font-weight: 600;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_customBox__Q142H {
  /* max-height: 111px; */
  margin: 0 auto;
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_box__wQhcQ i {
  color: inherit;

}

.gapsy-dashboard_group3__lFgzH:hover i {
  transform: rotate(10deg) scale(1.1);
}

.gapsy-dashboard_group3__lFgzH .gapsy-dashboard_box__wQhcQ {
  font-weight: 600;
  margin: 0 auto;
  max-width: 130px;
}


/* Active box: visual highlight */
.gapsy-dashboard_activeBox__vOWxQ {
  border: 2px solid #ffffff;
  /* box-shadow: 0 0 10px 3px rgba(255, 255, 255, 0.5); */
}

/* Disabled box: grayed out and unclickable */
.gapsy-dashboard_disabledBox__gvLix {
  cursor: not-allowed;
}

.gapsy-dashboard_fadeIn__LRCZZ {
  animation: gapsy-dashboard_fadeInScale__fggtA 0.4s ease-out forwards;
}

.gapsy-dashboard_highlightGlow__8Mo1b {
  box-shadow: 0 0 15px 4px rgba(255, 255, 255, 0.6),
    0 0 10px 2px rgba(57, 73, 171, 0.8);
  border: 2px solid #fff;
  position: relative;
  z-index: 1;
  animation: gapsy-dashboard_pulseGlow__nEwCW 1.5s infinite ease-in-out;
}

.gapsy-dashboard_highlightGlow__8Mo1b:hover {
  animation-play-state: paused;
}

@keyframes gapsy-dashboard_pulseGlow__nEwCW {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }

  50% {
    transform: scale(1.05);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0.6;
  }
}


@keyframes gapsy-dashboard_fadeIn__LRCZZ {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.gapsy-dashboard_breadcrumbItem__QkhLj {
  display: flex;
  align-items: center;
  color: #343a40;
}

/* Disable the Bootstrap auto '>' separator */
.gapsy-dashboard_breadcrumbItem__QkhLj+.gapsy-dashboard_breadcrumbItem__QkhLj::before {
  content: none !important;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: none !important;
}

.gapsy-dashboard_breadcrumbLink__fo9Aq {
  text-decoration: none;
  color: var(--bs-info);
  /* or custom */
}

.gapsy-dashboard_separator__wmkGT {
  margin: 0 0.5rem;
  color: #343a40;
}

.gapsy-dashboard_containerRow__qQp6c {
  border: 1px solid black !important;
  /* black border instead of white */
  border-radius: 0.25rem;
  /* keep rounded corners */
  padding: 1rem;
  /* padding for inner spacing */
}

.gapsy-dashboard_subheading__QNkuD {
  /* border-bottom: 1px solid black; */
  /* background-color: #007b8a; */
  /* Teal */
  color: black;
  /* border-bottom: 1px solid black; */
  font-size: 1rem;
  font-weight: 400;
  /* fw-bold */
}

.gapsy-dashboard_supportedFileFormats__4W4L7 {
  border-right: 1px solid black;
  padding-right: 1rem;
}

.gapsy-dashboard_customBtn__fx5ZK {
  color: #3d405b;
  border-color: #3d405b;
}

.gapsy-dashboard_customBtn__fx5ZK:hover {
  background-color: #3d405b;
  color: white;
}

.gapsy-dashboard_customRadio__qjix0 input[type="radio"] {
  accent-color: #3d405b;
}

.gapsy-dashboard_iconFormatOption__lD-Kc:hover {
  transform: scale(1.1);
  background-color: #f8f9fa;
  border-color: #0d6efd !important;
}

/* scrollable Body of card*/
/* Builder.module.css */

.gapsy-dashboard_scrollableCard__-Ffda {
  height: 50vh;
  overflow: hidden;
}

.gapsy-dashboard_scrollableBody__qpegq {
  overflow-y: auto;
  max-height: calc(50vh - 100px);
  /* Adjust as needed */
  padding-right: 8px;
  /* Prevent content cutoff behind scrollbar */
}

/* Adjust max height for the second card that includes a footer */
.gapsy-dashboard_scrollableBodyWithFooter__BXsyk {
  overflow-y: auto;
  max-height: calc(50vh - 160px);
  padding-right: 4px;
}

/* Optional custom scrollbar for WebKit browsers */
.gapsy-dashboard_scrollableBody__qpegq::-webkit-scrollbar,
.gapsy-dashboard_scrollableBodyWithFooter__BXsyk::-webkit-scrollbar {
  width: 6px;
}

.gapsy-dashboard_scrollableBody__qpegq::-webkit-scrollbar-thumb,
.gapsy-dashboard_scrollableBodyWithFooter__BXsyk::-webkit-scrollbar-thumb {
  background-color: #ced4da;
  border-radius: 4px;
}

/* search box */
.gapsy-dashboard_search-box-wrapper__Ob7wO {
  position: absolute;
  right: 100%;
  /* Expand to the left of icon */
  top: 0;
  width: 0;
  opacity: 0;
  overflow: hidden;
  transition: width 0.4s ease, opacity 0.3s ease;
  z-index: 1000;
}

#gapsy-dashboard_searchBoxCollapse__sjM98.gapsy-dashboard_show__6f8J8 {
  width: 200px;
  opacity: 1;
}

.gapsy-dashboard_ibmListGroup1__otnVo,
.gapsy-dashboard_ibmListGroup2__MqIcc {
  margin: 1px;
  padding: 3px;
  cursor: pointer;
  list-style: circle;
  list-style-type: disc;
  /* show bullet */
  list-style-position: inside;
}

.gapsy-dashboard_ibmListGroup1__otnVo:hover,
.gapsy-dashboard_ibmListGroup2__MqIcc:hover {
  background-color: #eaf4ff !important;
  color: black !important;
  cursor: pointer;
}

.gapsy-dashboard_ibmActiveColumn__cSXoo {
  background-color: #eaf4ff !important;
  color: black !important;
  cursor: pointer;
}

.gapsy-dashboard_customCheckboxLabel__WOg7r {
  display: block;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
  color: black;
  /* margin-left: 5px; */
}

.gapsy-dashboard_verticalDivider__ZL3Fg {
  border-right: 1px solid black;
}

.gapsy-dashboard_uploadArea__FZdOb {
  border: 2px dashed #0d6efd;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* notification hovering style */

.gapsy-dashboard_notificationItem__rvFo- {
  cursor: pointer;
  transition: all 0.2s ease;

  border-radius: 4px;
  /* Optional: rounded corners */
}

.gapsy-dashboard_notificationItem__rvFo-:hover {
  background-color: #f0f7ff;
  /* Light blue background */
  color: #0066cc;
  /* Darker blue text */
}

.gapsy-dashboard_notificationItem__rvFo-:hover strong {
  color: #004080;
  /* Even darker blue for bold text */
}

/* OrientationButtons.module.css */
.gapsy-dashboard_orientation__zExKK {
  color: #0dcaf0;
  /* Default text-info color */
}

.gapsy-dashboard_orientation__zExKK:hover i,
.gapsy-dashboard_active__NeJ7k.gapsy-dashboard_orientation__zExKK i {
  color: white !important;
  /* Change icon color on hover and when active */
}

.gapsy-dashboard_smallHeading__dUOZR {
  font-size: 14px;
}

.gapsy-dashboard_checksumDetails__-oN9- {
  font-size: 12px;
  color: black;
  display: flex;
  flex-wrap: wrap;
  gap: 1px;
}


.gapsy-dashboard_customtemplatebox__uZJoQ {
  background-color: white;
  border-radius: 11px;
  border: 1px solid #000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  overflow: hidden;
  padding-top: 5px;
  font-weight: 500;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-dashboard.module.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,eAAe;EACf,UAAU;EACV;uCACqC;EACrC,eAAe;EACf,yDAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,sCAAsC;AACtC;EACE,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+DAAgE;EAChE,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE;mBACiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;EAC1D,oDAAoD;AACtD;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,oDAAoD;AACtD;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,0DAA0D;EAC1D,oDAAoD;AACtD;;AAEA;EACE,0DAA0D;EAC1D,oDAAoD;AACtD;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB;yCACuC;EACvC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;;AAGA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;AACrB;;AAEA;EACE,oEAA6C;AAC/C;;AAEA;EACE;uCACqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,qEAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;;AAGA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B,uBAAuB;;AAEvB;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;;EAEE,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,MAAM;EACN,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,yBAAyB;;EAEzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;;AAGA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Dashboard.module.css */\r\n\r\n.pageFullBackground {\r\n  /* margin: 0; */\r\n  padding: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    \"Helvetica Neue\", Arial, sans-serif;\r\n  font-size: 12px;\r\n  background-image: url(\"../images/bg-11.jpg\");\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.mainHeader {\r\n  background-image: url(\"../images/bg-11.jpg\");\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-attachment: fixed;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1030;\r\n  height: 56px;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.stickyNav {\r\n  position: sticky;\r\n  top: 56px;\r\n  z-index: 1020;\r\n  background-color: #366872;\r\n  color: white;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.navLink {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  color: white;\r\n}\r\n\r\n.active.navLink {\r\n  color: #ffd166;\r\n  padding: 6px 10px;\r\n  text-decoration: none;\r\n}\r\n\r\n.navLinkDefault {\r\n  padding: 6px 10px;\r\n  text-decoration: none;\r\n}\r\n\r\n.badgeSmall {\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.hoverText:hover {\r\n  color: #03045e !important;\r\n}\r\n\r\n.textInfo {\r\n  color: #000 !important;\r\n}\r\n\r\n.dropdownSubmenuList {\r\n  top: 0;\r\n  left: 100%;\r\n  margin-top: -1px;\r\n}\r\n\r\n.dropdownToggleArrow::after {\r\n  border-left: 0.3em solid transparent;\r\n  border-right: 0.3em solid transparent;\r\n  border-top: 0.3em solid;\r\n  content: \"\";\r\n  float: right;\r\n  margin-top: 0.5em;\r\n  margin-left: 0.5em;\r\n}\r\n\r\n.dropdownItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.dropdownMenu {\r\n  min-width: 200px;\r\n}\r\n\r\n.dropdownMenuStyled {\r\n  background-color: #366872;\r\n  color: #fff;\r\n  border: none;\r\n}\r\n\r\n/* Add scroll to dropdown */\r\n.dropdownMenu {\r\n  max-height: 200px;\r\n  /* Adjust as needed for ~5 items */\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Optional: scrollbar styling for the dropdown */\r\n.dropdownMenu::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.dropdownMenu::-webkit-scrollbar-thumb {\r\n  background-color: #7cbbc8;\r\n  border-radius: 3px;\r\n}\r\n\r\n.dropdownMenu {\r\n  max-height: 160px;\r\n  overflow-y: auto;\r\n  max-width: 240px;\r\n  /* or set a fixed width if needed */\r\n  white-space: normal;\r\n  /* allow wrapping */\r\n  word-break: break-word;\r\n  /* break long words if needed */\r\n  padding-right: 4px;\r\n}\r\n\r\n.dropdownMenu::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.dropdownMenu::-webkit-scrollbar-thumb {\r\n  background-color: #7cbbc8;\r\n  border-radius: 3px;\r\n}\r\n\r\n/* Submenu Dropdown */\r\n.dropdownSubmenu {\r\n  position: relative;\r\n}\r\n\r\n.submenu {\r\n  display: none;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 100%;\r\n  margin-top: -0.125rem;\r\n  min-width: 200px;\r\n  z-index: 1050;\r\n}\r\n\r\n.dropdownSubmenu:hover .submenu {\r\n  display: block;\r\n}\r\n\r\n\r\n.dropdownMenuStyled a,\r\n.dropdownMenuStyled i {\r\n  color: #fff !important;\r\n}\r\n\r\n.mainContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.formLabel {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.chartContainer {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.legend {\r\n  font-size: 12px;\r\n}\r\n\r\n.legendItem {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  color: #fff;\r\n}\r\n\r\n.legendColor {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  margin-right: 6px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .main-container {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n/* Position the submenu to the right */\r\n.dropdownSubmenu .dropdownMenu {\r\n  top: 0;\r\n  left: 100%;\r\n  margin-top: -0.125rem;\r\n  display: none;\r\n  opacity: 0;\r\n  transform: translateX(10px);\r\n  transition: opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n/* Show submenu on hover */\r\n.dropdownSubmenu:hover>.dropdownMenu {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: translateX(0);\r\n}\r\n\r\n/* Prevent submenu from closing parent */\r\n.dropdownSubmenu>.dropdownToggle::after {\r\n  content: \" \\25B6\";\r\n  /* Right arrow */\r\n  float: right;\r\n}\r\n\r\n.dropdownMenu .dropdownItem i {\r\n  color: #6c757d;\r\n}\r\n\r\n.dropdownMenu a.dropdownItem:hover {\r\n  background-color: #ccc;\r\n}\r\n\r\na.dropdownItem,\r\n.dropdown-adjustables {\r\n  font-size: 12px;\r\n}\r\n\r\n.card {\r\n  background: none;\r\n  border: 1px solid #3d405b !important;\r\n}\r\n\r\n.borderBottom {\r\n  border-bottom: 1px solid #3d405b !important;\r\n}\r\n\r\n.borderTop {\r\n  border-top: 1px solid #3d405b !important;\r\n}\r\n\r\n.cardBorder {\r\n  border: 1px solid #3d405b !important;\r\n}\r\n\r\n.card h6 {\r\n  color: #000;\r\n}\r\n\r\n.card a {\r\n  color: #000;\r\n}\r\n\r\n.customCardChart {\r\n  background: #fff;\r\n  border-radius: 0px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.customCardChart h6 {\r\n  font-size: 12px;\r\n}\r\n\r\n.customCardChart:hover {\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.circleValue {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(45deg, #667eea, #764ba2);\r\n  /* Indigo to Purple */\r\n  font-size: 16px;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Logirent Demo\";\r\n  src: url(\"./fonts/Logirent-Regular-Demo.ttf\") format(\"truetype\");\r\n  /* format should be 'truetype' for .ttf files */\r\n}\r\n\r\n.h5LogoFont {\r\n  font-family: \"Logirent Demo\", sans-serif !important;\r\n}\r\n\r\nli.navItem a {\r\n  font-size: 12px !important;\r\n}\r\n\r\nfooter a {\r\n  font-size: 12px;\r\n}\r\n\r\n.legendItem {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.legendColor {\r\n  width: 12px;\r\n  height: 12px;\r\n  display: inline-block;\r\n  margin-right: 5px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.legendLabel {\r\n  white-space: nowrap;\r\n}\r\n\r\n.legendItem {\r\n  font-size: 0.25rem;\r\n  gap: 5px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.legendItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  /* spacing between color dot and label */\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n}\r\n\r\n#chartLegend {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  /* space between legend items */\r\n  flex-wrap: nowrap;\r\n  /* <== prevents wrapping to next row */\r\n  font-size: 13px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.legendItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.legendColor {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n}\r\n\r\n.legendLabel {\r\n  display: inline;\r\n  line-height: 1;\r\n}\r\n\r\n.chartLegend .legendLabel {\r\n  font-size: 12px !important;\r\n  margin-left: 4px;\r\n}\r\n\r\n.customBox {\r\n  color: #fff;\r\n  border-radius: 12px;\r\n  padding: 3px;\r\n  text-align: center;\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  position: relative;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 13px !important;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.customBox:hover {\r\n  transform: translateY(-5px);\r\n  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); */\r\n}\r\n\r\n.customBox i {\r\n  font-size: 28px;\r\n  display: block;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.customBox:hover i {\r\n  transform: rotate(10deg) scale(1.1);\r\n}\r\n\r\n\r\n.box {\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.box:hover {\r\n  transform: translateY(-5px);\r\n  /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1); */\r\n}\r\n\r\n.box i {\r\n  /* font-size: 28px;\r\n  display: block; */\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.box:hover i {\r\n  transform: rotate(10deg) scale(1.1);\r\n}\r\n\r\n/* Box-specific gradient classes */\r\n.csBoxMain {\r\n  /* background: linear-gradient(45deg, #3949AB, #2962FF); */\r\n  /* background: linear-gradient(45deg, #7f5539, #b08968); */\r\n  /* background: linear-gradient(45deg, #450920, #da627d); */\r\n  background: linear-gradient(45deg, #07beb8, #967aa1);\r\n}\r\n\r\n.csBoxBlue {\r\n  /* background: linear-gradient(45deg, #1E88E5, #42A5F5); */\r\n  /* background: linear-gradient(45deg, #f25c54, #f4845f); */\r\n  background: linear-gradient(45deg, #f25c54, #967aa1);\r\n}\r\n\r\n.csBoxPurple {\r\n  /* background: linear-gradient(45deg, #5E35B1, #7E57C2); */\r\n  /* background: linear-gradient(45deg, #6a11cb, #03f95d); */\r\n  /* background: linear-gradient(45deg, #133c55, #386fa4); */\r\n  background: linear-gradient(45deg, #ffc43d, #967aa1);\r\n}\r\n\r\n.csBoxDarkGreen {\r\n  /* background: linear-gradient(45deg, #1b9c85, #43aa8b); */\r\n  background: linear-gradient(45deg, #133c55, #967aa1);\r\n}\r\n\r\n/* Override for Overall Workflow (group3) boxes */\r\n.group3 .csBoxTeal {\r\n  background-color: #f8f9fa;\r\n  /* light neutral bg */\r\n  border: 2px solid #133c55;\r\n  color: #133c55;\r\n}\r\n\r\n.group3 .csBoxYellow {\r\n  background-color: #f8f9fa;\r\n  border: 2px solid #f8f9fa;\r\n  color: #000;\r\n}\r\n\r\n.group3 .csBoxGreen {\r\n  background-color: #f8f9fa;\r\n  /* border: 2px solid #770058;\r\n                        color: #600047; */\r\n  border: 2px solid #07beb8;\r\n  color: #07beb8;\r\n}\r\n\r\n.group3 .customBox i {\r\n  color: inherit;\r\n}\r\n\r\n.group3 .customBox {\r\n  font-weight: 600;\r\n}\r\n\r\n.group3 .customBox {\r\n  /* max-height: 111px; */\r\n  margin: 0 auto;\r\n}\r\n\r\n.group3 .box i {\r\n  color: inherit;\r\n\r\n}\r\n\r\n.group3:hover i {\r\n  transform: rotate(10deg) scale(1.1);\r\n}\r\n\r\n.group3 .box {\r\n  font-weight: 600;\r\n  margin: 0 auto;\r\n  max-width: 130px;\r\n}\r\n\r\n\r\n/* Active box: visual highlight */\r\n.activeBox {\r\n  border: 2px solid #ffffff;\r\n  /* box-shadow: 0 0 10px 3px rgba(255, 255, 255, 0.5); */\r\n}\r\n\r\n/* Disabled box: grayed out and unclickable */\r\n.disabledBox {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.fadeIn {\r\n  animation: fadeInScale 0.4s ease-out forwards;\r\n}\r\n\r\n.highlightGlow {\r\n  box-shadow: 0 0 15px 4px rgba(255, 255, 255, 0.6),\r\n    0 0 10px 2px rgba(57, 73, 171, 0.8);\r\n  border: 2px solid #fff;\r\n  position: relative;\r\n  z-index: 1;\r\n  animation: pulseGlow 1.5s infinite ease-in-out;\r\n}\r\n\r\n.highlightGlow:hover {\r\n  animation-play-state: paused;\r\n}\r\n\r\n@keyframes pulseGlow {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 0.6;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.05);\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 0.6;\r\n  }\r\n}\r\n\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n.breadcrumbItem {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #343a40;\r\n}\r\n\r\n/* Disable the Bootstrap auto '>' separator */\r\n.breadcrumbItem+.breadcrumbItem::before {\r\n  content: none !important;\r\n}\r\n\r\n:global(.breadcrumb-item + .breadcrumb-item::before) {\r\n  content: none !important;\r\n}\r\n\r\n.breadcrumbLink {\r\n  text-decoration: none;\r\n  color: var(--bs-info);\r\n  /* or custom */\r\n}\r\n\r\n.separator {\r\n  margin: 0 0.5rem;\r\n  color: #343a40;\r\n}\r\n\r\n.containerRow {\r\n  border: 1px solid black !important;\r\n  /* black border instead of white */\r\n  border-radius: 0.25rem;\r\n  /* keep rounded corners */\r\n  padding: 1rem;\r\n  /* padding for inner spacing */\r\n}\r\n\r\n.subheading {\r\n  /* border-bottom: 1px solid black; */\r\n  /* background-color: #007b8a; */\r\n  /* Teal */\r\n  color: black;\r\n  /* border-bottom: 1px solid black; */\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  /* fw-bold */\r\n}\r\n\r\n.supportedFileFormats {\r\n  border-right: 1px solid black;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.customBtn {\r\n  color: #3d405b;\r\n  border-color: #3d405b;\r\n}\r\n\r\n.customBtn:hover {\r\n  background-color: #3d405b;\r\n  color: white;\r\n}\r\n\r\n.customRadio input[type=\"radio\"] {\r\n  accent-color: #3d405b;\r\n}\r\n\r\n.iconFormatOption:hover {\r\n  transform: scale(1.1);\r\n  background-color: #f8f9fa;\r\n  border-color: #0d6efd !important;\r\n}\r\n\r\n/* scrollable Body of card*/\r\n/* Builder.module.css */\r\n\r\n.scrollableCard {\r\n  height: 50vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.scrollableBody {\r\n  overflow-y: auto;\r\n  max-height: calc(50vh - 100px);\r\n  /* Adjust as needed */\r\n  padding-right: 8px;\r\n  /* Prevent content cutoff behind scrollbar */\r\n}\r\n\r\n/* Adjust max height for the second card that includes a footer */\r\n.scrollableBodyWithFooter {\r\n  overflow-y: auto;\r\n  max-height: calc(50vh - 160px);\r\n  padding-right: 4px;\r\n}\r\n\r\n/* Optional custom scrollbar for WebKit browsers */\r\n.scrollableBody::-webkit-scrollbar,\r\n.scrollableBodyWithFooter::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.scrollableBody::-webkit-scrollbar-thumb,\r\n.scrollableBodyWithFooter::-webkit-scrollbar-thumb {\r\n  background-color: #ced4da;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* search box */\r\n.search-box-wrapper {\r\n  position: absolute;\r\n  right: 100%;\r\n  /* Expand to the left of icon */\r\n  top: 0;\r\n  width: 0;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  transition: width 0.4s ease, opacity 0.3s ease;\r\n  z-index: 1000;\r\n}\r\n\r\n#searchBoxCollapse.show {\r\n  width: 200px;\r\n  opacity: 1;\r\n}\r\n\r\n.ibmListGroup1,\r\n.ibmListGroup2 {\r\n  margin: 1px;\r\n  padding: 3px;\r\n  cursor: pointer;\r\n  list-style: circle;\r\n  list-style-type: disc;\r\n  /* show bullet */\r\n  list-style-position: inside;\r\n}\r\n\r\n.ibmListGroup1:hover,\r\n.ibmListGroup2:hover {\r\n  background-color: #eaf4ff !important;\r\n  color: black !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.ibmActiveColumn {\r\n  background-color: #eaf4ff !important;\r\n  color: black !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.customCheckboxLabel {\r\n  display: block;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n  text-overflow: unset;\r\n  color: black;\r\n  /* margin-left: 5px; */\r\n}\r\n\r\n.verticalDivider {\r\n  border-right: 1px solid black;\r\n}\r\n\r\n.uploadArea {\r\n  border: 2px dashed #0d6efd;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* notification hovering style */\r\n\r\n.notificationItem {\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n\r\n  border-radius: 4px;\r\n  /* Optional: rounded corners */\r\n}\r\n\r\n.notificationItem:hover {\r\n  background-color: #f0f7ff;\r\n  /* Light blue background */\r\n  color: #0066cc;\r\n  /* Darker blue text */\r\n}\r\n\r\n.notificationItem:hover strong {\r\n  color: #004080;\r\n  /* Even darker blue for bold text */\r\n}\r\n\r\n/* OrientationButtons.module.css */\r\n.orientation {\r\n  color: #0dcaf0;\r\n  /* Default text-info color */\r\n}\r\n\r\n.orientation:hover i,\r\n.active.orientation i {\r\n  color: white !important;\r\n  /* Change icon color on hover and when active */\r\n}\r\n\r\n.smallHeading {\r\n  font-size: 14px;\r\n}\r\n\r\n.checksumDetails {\r\n  font-size: 12px;\r\n  color: black;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1px;\r\n}\r\n\r\n\r\n.customtemplatebox {\r\n  background-color: white;\r\n  border-radius: 11px;\r\n  border: 1px solid #000;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  overflow: hidden;\r\n  padding-top: 5px;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageFullBackground": `gapsy-dashboard_pageFullBackground__gyEDE`,
	"mainHeader": `gapsy-dashboard_mainHeader__VunT4`,
	"stickyNav": `gapsy-dashboard_stickyNav__kQu+i`,
	"navLink": `gapsy-dashboard_navLink__+s+wp`,
	"active": `gapsy-dashboard_active__NeJ7k`,
	"navLinkDefault": `gapsy-dashboard_navLinkDefault__reYk5`,
	"badgeSmall": `gapsy-dashboard_badgeSmall__hfer8`,
	"hoverText": `gapsy-dashboard_hoverText__vvDCM`,
	"textInfo": `gapsy-dashboard_textInfo__lMhLf`,
	"dropdownSubmenuList": `gapsy-dashboard_dropdownSubmenuList__euzgm`,
	"dropdownToggleArrow": `gapsy-dashboard_dropdownToggleArrow__+sgBb`,
	"dropdownItem": `gapsy-dashboard_dropdownItem__80cqI`,
	"dropdownMenu": `gapsy-dashboard_dropdownMenu__ccoAg`,
	"dropdownMenuStyled": `gapsy-dashboard_dropdownMenuStyled__U1G4P`,
	"dropdownSubmenu": `gapsy-dashboard_dropdownSubmenu__kuUjC`,
	"submenu": `gapsy-dashboard_submenu__x3iHJ`,
	"mainContainer": `gapsy-dashboard_mainContainer__dawLX`,
	"formLabel": `gapsy-dashboard_formLabel__2xN41`,
	"chartContainer": `gapsy-dashboard_chartContainer__j90OE`,
	"legend": `gapsy-dashboard_legend__JE6xZ`,
	"legendItem": `gapsy-dashboard_legendItem__SCZQS`,
	"legendColor": `gapsy-dashboard_legendColor__XPc9M`,
	"main-container": `gapsy-dashboard_main-container__iwI9v`,
	"dropdownToggle": `gapsy-dashboard_dropdownToggle__va2pM`,
	"dropdown-adjustables": `gapsy-dashboard_dropdown-adjustables__AELam`,
	"card": `gapsy-dashboard_card__cHaOX`,
	"borderBottom": `gapsy-dashboard_borderBottom__RiHZX`,
	"borderTop": `gapsy-dashboard_borderTop__+Fvr0`,
	"cardBorder": `gapsy-dashboard_cardBorder__vjAx0`,
	"customCardChart": `gapsy-dashboard_customCardChart__bvPcO`,
	"circleValue": `gapsy-dashboard_circleValue__B2Xk6`,
	"h5LogoFont": `gapsy-dashboard_h5LogoFont__cTQaN`,
	"navItem": `gapsy-dashboard_navItem__GxHA1`,
	"legendLabel": `gapsy-dashboard_legendLabel__R8Q-I`,
	"chartLegend": `gapsy-dashboard_chartLegend__H4rx1`,
	"customBox": `gapsy-dashboard_customBox__Q142H`,
	"box": `gapsy-dashboard_box__wQhcQ`,
	"csBoxMain": `gapsy-dashboard_csBoxMain__QZIFU`,
	"csBoxBlue": `gapsy-dashboard_csBoxBlue__MhNKh`,
	"csBoxPurple": `gapsy-dashboard_csBoxPurple__lvYz-`,
	"csBoxDarkGreen": `gapsy-dashboard_csBoxDarkGreen__59AgF`,
	"group3": `gapsy-dashboard_group3__lFgzH`,
	"csBoxTeal": `gapsy-dashboard_csBoxTeal__74uY9`,
	"csBoxYellow": `gapsy-dashboard_csBoxYellow__HXgKi`,
	"csBoxGreen": `gapsy-dashboard_csBoxGreen__neHD8`,
	"activeBox": `gapsy-dashboard_activeBox__vOWxQ`,
	"disabledBox": `gapsy-dashboard_disabledBox__gvLix`,
	"fadeIn": `gapsy-dashboard_fadeIn__LRCZZ`,
	"fadeInScale": `gapsy-dashboard_fadeInScale__fggtA`,
	"highlightGlow": `gapsy-dashboard_highlightGlow__8Mo1b`,
	"pulseGlow": `gapsy-dashboard_pulseGlow__nEwCW`,
	"breadcrumbItem": `gapsy-dashboard_breadcrumbItem__QkhLj`,
	"breadcrumbLink": `gapsy-dashboard_breadcrumbLink__fo9Aq`,
	"separator": `gapsy-dashboard_separator__wmkGT`,
	"containerRow": `gapsy-dashboard_containerRow__qQp6c`,
	"subheading": `gapsy-dashboard_subheading__QNkuD`,
	"supportedFileFormats": `gapsy-dashboard_supportedFileFormats__4W4L7`,
	"customBtn": `gapsy-dashboard_customBtn__fx5ZK`,
	"customRadio": `gapsy-dashboard_customRadio__qjix0`,
	"iconFormatOption": `gapsy-dashboard_iconFormatOption__lD-Kc`,
	"scrollableCard": `gapsy-dashboard_scrollableCard__-Ffda`,
	"scrollableBody": `gapsy-dashboard_scrollableBody__qpegq`,
	"scrollableBodyWithFooter": `gapsy-dashboard_scrollableBodyWithFooter__BXsyk`,
	"search-box-wrapper": `gapsy-dashboard_search-box-wrapper__Ob7wO`,
	"searchBoxCollapse": `gapsy-dashboard_searchBoxCollapse__sjM98`,
	"show": `gapsy-dashboard_show__6f8J8`,
	"ibmListGroup1": `gapsy-dashboard_ibmListGroup1__otnVo`,
	"ibmListGroup2": `gapsy-dashboard_ibmListGroup2__MqIcc`,
	"ibmActiveColumn": `gapsy-dashboard_ibmActiveColumn__cSXoo`,
	"customCheckboxLabel": `gapsy-dashboard_customCheckboxLabel__WOg7r`,
	"verticalDivider": `gapsy-dashboard_verticalDivider__ZL3Fg`,
	"uploadArea": `gapsy-dashboard_uploadArea__FZdOb`,
	"notificationItem": `gapsy-dashboard_notificationItem__rvFo-`,
	"orientation": `gapsy-dashboard_orientation__zExKK`,
	"smallHeading": `gapsy-dashboard_smallHeading__dUOZR`,
	"checksumDetails": `gapsy-dashboard_checksumDetails__-oN9-`,
	"customtemplatebox": `gapsy-dashboard_customtemplatebox__uZJoQ`
};
export default ___CSS_LOADER_EXPORT___;
